module.exports = __webpack_public_path__ + "static/media/drugs-1728381_640.c982ea57.jpg";